(function(SCS, $) {
	'use strict';

	var search = SCS.search = SCS.search || {};

	function deduplicatedBackend(backend) {
		var pending = {};
		function backendDeduplicator(url, callback, processor, config) {
			// jshint validthis: true
			var duplicate = url in pending;

			var current = pending[url] = pending[url] || {callbacks: [], result: null};
			current.callbacks.push(callback);

			var handle = {
				abort: function() {
					var index = search.util.inArray(callback, current.callbacks);
					if(index !== -1) {
						current.callbacks.splice(index, 1);
					}
					if(!current.callbacks.length) {
						current.result.abort();
					}
				}
			};

			if(duplicate) {
				return handle;
			}

			current.result = backend.call(this, url, function() {
				delete pending[url];
				for(var i=0;i<current.callbacks.length;i+=1) {
					current.callbacks[i].apply(this, arguments);
				}
			}, processor, config);

			return handle;
		}
		backendDeduplicator.displayName = deduplicatedBackend.name + ': ' + (backend.displayName || backend.name);
		return backendDeduplicator;
	}

	var DEFAULT_CACHE_SIZE = 20;
	var DEFAULT_CACHE_TOLERANCE = 0.5;
	function cachedBackend(backend, cacheSize, tolerance) {
		cacheSize = cacheSize || DEFAULT_CACHE_SIZE;
		tolerance = tolerance || DEFAULT_CACHE_TOLERANCE;

		var maxSize = Math.ceil(cacheSize * (1 + tolerance));

		var cache = {};
		var currentSize = 0;

		function cleanCache() {
			// Clean up stale cache entries
			if(currentSize <= maxSize) {
				return;
			}
			var toRemove = Math.max(currentSize - cacheSize, 0);
			var ordered = [];
			for(var k in cache) {
				// jshint forin: false
				ordered.push(k);
			}
			ordered.sort(function(a, b) {
				return cache[a].ts - cache[b].ts;
			});
			for(var i=0;i<toRemove;i+=1) {
				delete cache[ordered[i]];
				currentSize -= 1;
			}
		}

		function purgeCache() {
			cache = {};
		}

		function backendCacher(url, callback, processor, config) {
			// jshint validthis: true
			if(url in cache) {
				cache[url].ts = +new Date();
				// Cannot abort cached requests because they are synchronous
				return callback.apply(this, cache[url].data);
			}
			return backend.call(this, url, function() {
				if(!(arguments[0] instanceof Error)) {
					cache[url] = {data: arguments, ts: +new Date()};
					currentSize += 1;
					cleanCache();
				}
				callback.apply(this, arguments);
			}, processor, config);
		}

		backendCacher.purgeCache = purgeCache;
		backendCacher.displayName = cachedBackend.name + ': ' + (backend.displayName || backend.name);

		return backendCacher;
	}

	function ajaxBackend(ajaxOptions) {
		// A backend function that does a real XMLHttpRequest using a jQuery.ajax GET request
		ajaxOptions = ajaxOptions || {};
		return function jQueryBackend(url, callback) {
			var match = url.match(/^\[(\w+)\](.*)$/) || [];
			url = match[2] || url;
			var method = match[1] || 'GET';
			var opts = search.util.extend({}, ajaxOptions, {
				url: url,
				type: method
			});
			var request = $.ajax(opts).done(callback).fail(function(xhr, textStatus, errorThrown) {
				if(!errorThrown || !(errorThrown instanceof Error)) {
					errorThrown = new Error(errorThrown || textStatus);
				}
				callback(errorThrown);
			});
			return {
				abort: function() {
					request.abort();
				}
			};
		};
	}

	var backend = search.backend = search.backend || {};
	backend.deduplicatedBackend = deduplicatedBackend;
	backend.cachedBackend = cachedBackend;
	backend.ajaxBackend = ajaxBackend;

	backend.defaultBackend = function defaultBackend() {
		if(!defaultBackend.instance) {
			var defaultAjaxBackend = ajaxBackend({
				dataType: 'json',
				timeout: 1800
			});
			// Caching must be done after deduplication to not cache concurrent requests
			defaultBackend.instance = deduplicatedBackend(cachedBackend(defaultAjaxBackend));
		}
		return defaultBackend.instance;
	};

})(window.SCS = window.SCS || {}, 'Tc' in window ? window.Tc.$ : window.$);


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/util/backends.js
// module id = 39
// module chunks = 0